import { Tag } from "@/types";

type Props = {
  tags?: Tag[];
  maxVisible?: number;
};

export default function TagDots({ tags, maxVisible = 2 }: Props) {
  if (!tags || tags.length === 0) return null;

  const visibleTags = tags.slice(0, maxVisible);
  const overflow = tags.length - maxVisible;

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {visibleTags.map((tag) => (
        <div
          key={tag.name}
          className="px-2 py-0.5 rounded-full text-xs"
          style={{
            backgroundColor: `${tag.color}20`,
            color: tag.color,
          }}
        >
          <span className="truncate max-w-[60px]">{tag.name}</span>
        </div>
      ))}
      {overflow > 0 && (
        <span className="text-[10px] text-[var(--text-muted)]">+{overflow}</span>
      )}
    </div>
  );
}
